import React, { Component } from 'react';
import PropTypes from 'prop-types';
import animateScrollTo from 'animated-scroll-to';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faAngleRight, faAngleLeft, faAngleDown, faAngleUp,
} from '@fortawesome/free-solid-svg-icons';
import exact from 'prop-types-exact';
import { transformHTML } from '../../../helpers/transformHTML';
import Button from '../../../common/button/Button';
import Slider from '../../../common/Slider/Slider';

class LyricsPane extends Component {
    constructor(props) {
        super(props);

        this.lyricsPanelRef = React.createRef(); // reference for the element with className="lyrics-panel"

        this.mobileLyricsRef = React.createRef(); // reference for the element with className="lyrics-panel-mb" (original lyrics)

        this.mobileTranslationRef = React.createRef(); // reference for the element with className="lyrics-panel-mb" (translation lyrics)

        this._openLyrics = this._openLyrics.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.music.artist !== this.props.music.artist) {
            const mobileLyricsRef = this.mobileLyricsRef.current;
            const mobileTranslationRef = this.mobileTranslationRef.current;
            const lyricsPanelRef = this.lyricsPanelRef.current;

            if (this.props.breakpoint.isSmall || this.props.breakpoint.isExtraSmall) {
                mobileLyricsRef && animateScrollTo(0, { speed: 3000, elementToScroll: mobileLyricsRef });

                mobileTranslationRef && animateScrollTo(0, { speed: 3000, elementToScroll: mobileTranslationRef });
            } else {
                lyricsPanelRef && animateScrollTo(0, { speed: 3000, elementToScroll: lyricsPanelRef });
            }
        }
    }

    _returnLyricsTranslation = (lyricsTranslation) => {
        if (lyricsTranslation) {
            return transformHTML(lyricsTranslation);
        }

        return <p>Tradução não disponivel</p>;
    }

    _returnLyrics = (lyrics) => {
        if (lyrics) {
            return transformHTML(lyrics);
        }

        return <p>Letra não disponivel</p>;
    }

    _scrollLyrics = (isUp) => {
        const lyricsPanelRef = this.lyricsPanelRef.current;

        if (isUp) {
            lyricsPanelRef.scrollTop += 40;
        } else {
            lyricsPanelRef.scrollTop -= 40;
        }
    }

    _openLyrics() {
        const mobileLyricsRef = this.mobileLyricsRef.current;
        const mobileTranslationRef = this.mobileTranslationRef.current;

        if (mobileLyricsRef.style.height !== 'inherit') {
            // Open
            mobileLyricsRef.style.height = 'inherit';

            mobileTranslationRef.style.height = 'inherit';
        } else {
            // Close
            mobileLyricsRef.style.height = '220px';

            mobileTranslationRef.style.height = '220px';
        }
    }

    _returnMobileLyricsStructure() {
        const structureLyrics = [
            <div key="Original lyrics">
                <div className="lyrics-mobileVersion">
                    <div className="language-box">
                        <div className="button">ORIGINAL</div>
                        <FontAwesomeIcon icon={faAngleRight} className="faAngleMobile" width="16" />
                    </div>
                    <div className="lyrics-panel-mb" ref={this.mobileLyricsRef}>
                        <div className="lyrics-box-parent">
                            <div className="lyrics-box">
                                {this._returnLyrics(this.props.music.lyrics)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>,
            <div key="Translated lyrics">
                <div className="lyrics-mobileVersion">
                    <div className="language-box ">
                        <div className="button">TRADUÇÃO</div>
                        <FontAwesomeIcon icon={faAngleLeft} className="faAngleMobile" width="16" />
                    </div>
                    <div className="lyrics-panel-mb" ref={this.mobileTranslationRef}>
                        <div className="lyrics-box-parent">
                            <div className="lyrics-box">
                                {this._returnLyricsTranslation(this.props.music.lyricsTranslation)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>,
        ];

        return (
            <div className="mobileSlider">
                <Slider
                    loop={false}
                    navigation
                    autoplay={false}
                >
                    {structureLyrics}
                </Slider>
            </div>
        );
    }

    render() {
        const music = this.props.music;
        const isMobile = this.props.breakpoint.isSmall || this.props.breakpoint.isExtraSmall;
        const lyricsTranslation = music.lyricsTranslation;
        const lyrics = music.lyrics;

        return (
            <div className="lyrics-pane">
                {/*
                    <header>
                        <h2>Letra de Música</h2>
                    </header>
                */}
                {(lyricsTranslation || lyrics) && !isMobile &&
                    <div className="lyrics-pane-title-language">
                        <div className="language-box-original" id="original">
                            <div className="button">Original</div>
                        </div>
                        <div className="language-box-traducao" id="traducao">
                            <div className="button">Tradução</div>
                        </div>
                    </div>}

                {(lyricsTranslation || lyrics) && isMobile ?
                    <div className="lyrics-panel-mb">
                        {' '}
                        {this._returnMobileLyricsStructure()}
                        <div className="fadedEffect">
                            <div className="arrowScroll">
                                <FontAwesomeIcon icon={faAngleDown} onClick={this._openLyrics} className="faAngleDownMobile" width="16" />
                            </div>
                        </div>
                    </div>
                    : lyricsTranslation || lyrics ?
                        <div className="lyrics-panel-wrapper">
                            <div className="lyrics-panel" ref={this.lyricsPanelRef}>
                                <div className="lyrics-panel-original">
                                    <div className="lyrics-box-parent">
                                        <div className="lyrics-box" aria-labelledby="original">
                                            {this._returnLyrics(lyrics)}
                                        </div>
                                    </div>
                                </div>
                                <div className="lyrics-panel-traducao">
                                    <div className="lyrics-box-parent">
                                        <div className="lyrics-box" aria-labelledby="traducao">
                                            {this._returnLyricsTranslation(lyricsTranslation)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="arrowScrollTop">
                                <FontAwesomeIcon icon={faAngleUp} onClick={() => this._scrollLyrics(false)} className="faAngleUp" width="16" tabIndex="0" />
                            </div>
                            <div className="fadedEffect">
                                <div className="arrowScroll">
                                    <FontAwesomeIcon icon={faAngleDown} onClick={() => this._scrollLyrics(true)} className="faAngleDown" width="16" tabIndex="0" />
                                </div>
                            </div>
                        </div>
                        :
                        <div className="lyrics-panel" style={{ height: 'auto', textAlign: 'center' }}>
                            <div className="noLyrics">
                                <div className="noLyrics-info">
                                    <p>
                                        Não existe uma letra disponível para essa faixa... :(
                                        <br />
                                        Entre em
                                        {' '}
                                        <Button to="/contato" title="Ir para página contato">contato</Button>
                                        {' '}
                                        para ajudar a completar a página!
                                    </p>
                                </div>
                            </div>
                        </div>}
            </div>
        );
    }
}

LyricsPane.propTypes = exact({
    music: PropTypes.object.isRequired,
    breakpoint: PropTypes.object,
});


export default LyricsPane;
